// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__DnrrU","title":"loader_title__WExIf","sub_title":"loader_sub_title__QfrLo","search":"loader_search__rxH8t","features":"loader_features__IHXOi"};